import { GraphQLClient } from 'graphql-request';
import config from '@resn/gozer-core/config';

const SHOPIFY_ACCESS_TOKEN = config.SHOPIFY_ACCESS_TOKEN;
const SHOPIFY_ENDPOINT = `https://${config.SHOPIFY_SHOPNAME}.myshopify.com/api/2021-10/graphql.json`;

const client = new GraphQLClient(SHOPIFY_ENDPOINT, {
    headers: {
        'X-Shopify-Storefront-Access-Token': SHOPIFY_ACCESS_TOKEN,
    },
});

export default client
